export default "__VITE_PUBLIC_ASSET__15e3605c__"